const data = [
    {
      id: 1,
      image: "https://img.icons8.com/ios/64/000000/menu.png",
      title: "MERN Stack",
      desc: "I have a lot of passion around MERN Stack (learner)",
    },
    {
      id: 2,
      image: "https://img.icons8.com/ios/40/000000/open-book.png",
      title: "BackEnd Development",
      desc: "I have some experience with it Node.js, Express, MongoDB (learner)",
    },
    {
      id: 3,
      image: "https://img.icons8.com/fluency-systems-regular/64/000000/retro-tv.png ",
      title: "FrontEnd Development",
      desc: "Worked on a variety of projects ranging from small websites to large-scale web applications, using technologies such as React, HTML, CSS, and JavaScript",
    },
    {
      id: 4,
      image: "https://img.icons8.com/material-outlined/64/000000/topic--v1.png ",
      title: "Mobile App",
      desc: "Worked on a variety of Android projects, using Java and Android SDK to develop mobile applications.",
    },
    {
      id: 5,
      image: "https://img.icons8.com/ios-filled/64/000000/wifi.png ",
      title: "CEO Marketing",
      desc: "always free from repetition, injected humour, or non-characteristic words etc.",
    },
    {
      id: 6,
      image: "https://img.icons8.com/glyph-neue/50/000000/polyline.png ",
      title: "Web App Development",
      desc: "Worked on a variety of projects ranging from small websites to large-scale web applications, using technologies such as React, HTML, CSS, and JavaScript"
    },
  ]
  export default data
  